import api from "../../services/api";
import Constants from "../../services/constants";
import { types } from "../types/types";
import { showToast } from "./toastAction";
import { hideLoaderAction, showLoaderAction } from "./loaderAction";

const handleError = (dispatch, res) => {
    if (!res?.success) {
        dispatch(showToast({ severity: "error", summary: res?.message || "Something went wrong" }));
        return true;
    }
    return false;
};

export const getPermissionCatalog = () => async (dispatch) => {
    const res = await api("get", Constants.END_POINT.SUB_ADMIN_PERMISSION_CATALOG);
    if (!handleError(dispatch, res)) {
        dispatch({ type: types.SUB_ADMIN_PERMISSION_CATALOG, payload: res.data || [] });
    }
    return res;
};

export const getSubAdmins = (setLoading) => async (dispatch) => {
    if (setLoading) setLoading(true);
    const res = await api("get", Constants.END_POINT.SUB_ADMINS);
    if (!handleError(dispatch, res)) {
        dispatch({ type: types.SUB_ADMINS, payload: res.data || [] });
    }
    if (setLoading) setLoading(false);
    return res;
};

export const getSubAdmin = (id) => async (dispatch) => {
    const res = await api("get", `${Constants.END_POINT.SUB_ADMINS}/${id}`);
    if (handleError(dispatch, res)) return null;
    return res.data;
};

export const createSubAdmin = (payload, onSuccess) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("post", Constants.END_POINT.SUB_ADMINS, payload);
    if (!handleError(dispatch, res)) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getSubAdmins());
        if (onSuccess) onSuccess(res.data);
    }
    dispatch(hideLoaderAction());
    return res;
};

export const updateSubAdmin = (id, payload, onSuccess) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("put", `${Constants.END_POINT.SUB_ADMINS}/${id}`, payload);
    if (!handleError(dispatch, res)) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getSubAdmins());
        if (onSuccess) onSuccess(res.data);
    }
    dispatch(hideLoaderAction());
    return res;
};

export const updateSubAdminStatus = (id, isActive, onSuccess) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("patch", `${Constants.END_POINT.SUB_ADMINS}/${id}/status`, { isActive });
    if (!handleError(dispatch, res)) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getSubAdmins());
        if (onSuccess) onSuccess(res.data);
    }
    dispatch(hideLoaderAction());
    return res;
};

export const resetSubAdminPassword = (id, newPassword, onSuccess) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("post", `${Constants.END_POINT.SUB_ADMINS}/${id}/reset-password`, { newPassword });
    if (!handleError(dispatch, res)) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        if (onSuccess) onSuccess(res.data);
    }
    dispatch(hideLoaderAction());
    return res;
};
